import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import CloneableInputGroup from 'library/components/cloneable-input-group';
import { InputEvent as SyntheticEvent } from 'library/helpers/synthetic-events';
import Toggle from 'library/components/form-elements/toggle';
import Tag from 'library/components/tag';

const CurrentYear = (new Date()).getFullYear()+10;

const EducationFields = ({ className='', data, onChange, baseKey = '', index, active=false }) => {
    const Years = [...Array(100).keys()].map(n=><option key={CurrentYear - n} value={CurrentYear - n}>{CurrentYear - n}</option>);

    const remove = () => {
        onChange(new SyntheticEvent({
            name: baseKey,
            value: undefined,
            type: 'object'
        }));
    }

    const handleChangeDate = (e) => {
        const { name, value } = e.target;
        const [ key, type ] = name.split('_');

        let [ year, month, day='01' ] = (resolve(data, `date_range.${key}`, '--1', '.') || '').split('-').map(v=>v||'');

        if (type === 'month') {
            month = value;
        } else if (type === 'year') {
            year = value;
        }

        onChange(new SyntheticEvent({
            name: `${baseKey}.date_range.${key}`,
            value: `${year}-${month}-01`
        }))
    }

    let [start_year='',start_month=''] = (resolve(data, 'date_range.start', '--1', '.') || '').split('-').map(v=>v||'');

    let [finish_year='',finish_month=''] = (resolve(data, 'date_range.finish', '--1', '.') || '').split('-').map(v=>v||'');

    return (
        <div className={className}>
            <label>
                School
                <input placeholder="School" type="text" onChange={onChange} value={data.school || ''} name={`${baseKey}.school`} disabled={!active} required={active} />
            </label>
            <label>
                Degree
                <select  onChange={onChange} value={data.degree || ''} name={`${baseKey}.degree`} disabled={!active} required={active}>
                  <option value="">-- Degree Type --</option>
                  <option value="high-school">High School</option>
                  <option value="associates">Associates</option>
                  <option value="bachelors">Bachelors</option>
                  <option value="masters">Masters</option>
                  <option value="doctorate">Doctorate</option>
                </select>
            </label>
            <label>
                Field of Study
                <input placeholder="Field of Study" type="text" onChange={onChange} value={data.field_of_study || ''} name={`${baseKey}.field_of_study`} disabled={!active} required={active} />
            </label>
            <label>
                Time Period
                <div className="select-group">
                    <div className="select-group">
                        <select onChange={handleChangeDate} value={start_month} name={`start_month`} disabled={!active} required={active}>
                            <option value="">Month</option>
                            <option value="01">January (01)</option>
                            <option value="02">February (02)</option>
                            <option value="03">March (03)</option>
                            <option value="04">April (04)</option>
                            <option value="05">May (05)</option>
                            <option value="06">June (06)</option>
                            <option value="07">July (07)</option>
                            <option value="08">August (08)</option>
                            <option value="09">September (09)</option>
                            <option value="10">October (10)</option>
                            <option value="11">November (11)</option>
                            <option value="12">December (12)</option>
                        </select>
                        <select onChange={handleChangeDate} value={start_year} name={`start_year`} disabled={!active} required={active}>
                            <option value="">Year</option>
                            { Years }
                        </select>
                    </div>
                    <span>TO</span>
                    <div className="select-group">
                        <select onChange={handleChangeDate} value={finish_month} name={`finish_month`} disabled={!active} required={active}>
                            <option value="">Month</option>
                            <option value="01">January (01)</option>
                            <option value="02">February (02)</option>
                            <option value="03">March (03)</option>
                            <option value="04">April (04)</option>
                            <option value="05">May (05)</option>
                            <option value="06">June (06)</option>
                            <option value="07">July (07)</option>
                            <option value="08">August (08)</option>
                            <option value="09">September (09)</option>
                            <option value="10">October (10)</option>
                            <option value="11">November (11)</option>
                            <option value="12">December (12)</option>
                        </select>
                        <select onChange={handleChangeDate} value={finish_year} name={`finish_year`} disabled={!active} required={active}>
                            <option value="">Year</option>
                            { Years }
                        </select>
                    </div>
                </div>
                <div><small><strong>Current Student:</strong> Use expected graduation date</small></div>
            </label>
            <label>
                Description
                <textarea placeholder="Education Description"  onChange={onChange} value={data.description || ''} name={`${baseKey}.description`} disabled={!active} />
            </label>
            <div className="resume-builder-fields-controls">
                <span className="a" onClick={() => remove()}>remove</span>
            </div>
        </div>
    )
}

const Education = ({ data, handleChange }) => {
    const hasEducation = resolve(data, 'has_education_histories', false, '.');

    const onChange = () => {
        handleChange(new SyntheticEvent({
            name: 'has_education_histories',
            value: !hasEducation
        }));
    }

    const fieldsClass = [
        "resume-builder-fields",
        !hasEducation ? 'resume-builder-fields-disabled' : null
    ].filter(c=>c).join(' ')

    return (
        <section className={!hasEducation ? 'resume-builder-multi-disabled' : ''}>
            <h1><Toggle name="education_histories" checked={hasEducation} onChange={onChange} /> Education <Tag className="tag-auxilary-4">Suggested for Resume Creation</Tag></h1>
            <p>
              Your education may be key to selecting your optimal career options. Once you pick a goal career, we may suggest additional certificates or degrees to accelerate your journey to career success.
            </p>
            <CloneableInputGroup disabled={!hasEducation} onChange={handleChange} values={data} dataKey="education_histories" className="resume-builder-multi">
                <EducationFields className={fieldsClass} active={hasEducation} onChange={handleChange} />
            </CloneableInputGroup>
        </section>
    )
}


export default Education;
